import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { SortEvent, NgbdSortableHeader } from '../../../../../Autofacets-Core/src/app/directives/sortable.directive';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { ApplicationVersionService } from './../../business-services/application-version.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UserDataService } from '../../../../../../src/app/DataServices/user-data.service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import * as fromEnums from './../../../../../Autofacets-Core/src/app/utils/enums';
import { CustomPaggerService } from '../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { AddApplicationVersionComponent } from './add-application-version/add-application-version.component';
import { EditApplicationVersionComponent } from './edit-application-version/edit-application-version.component';

@Component({
  selector: 'app-application-version',
  templateUrl: './application-version.component.html',
})
export class ApplicationVersionComponent implements OnInit{
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  applicationVersionList: any = [];
  paginationSub: Subscription;
  currentlagSub: Subscription;
  userRoleRightsDetails: UserRoleMenu;
  popupCloseResult = false;
  versionNumberList: any[] = [];
  totalCount: number = 0;
  selectedVersionNumber:string = null;
  total$: Observable<number>;
  latestVersionNumber: string = null;
  constructor(
    private readonly ApplicationVersionService : ApplicationVersionService,
    private readonly spinner: NgxSpinnerService,
    config: NgbModalConfig,
    private readonly userService: UserDataService,
    private readonly currentLanguageService: CurrentLanguage,
    public pService: CustomPaggerService,
    private readonly modalService: NgbModal,
  ) {
    this.pService.pageSize = 10;
    config.backdrop = 'static';
    config.keyboard = false;
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }
  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }
  ngOnInit(): void {
    this.pService.dataSource = [];
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.getVersionNumberList();
    // this.versionNumberList = [
    //   {"name":"1.0.1","value":"1.0.1"},
    //   {"name":"1.0.2","value":"1.0.2"},
    //   {"name":"1.0.3","value":"1.0.3"}
    // ]
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.ApplicationVersionDetails);

    this.ApplicationVersionService.applicationVersionListRequest.versionNumber = this.selectedVersionNumber;
    this.ApplicationVersionService.applicationVersionListRequest.startRecordNumber = 0;
    this.applicationVersionList = [];
  // this.applicationVersionList = [
  //   {"RowId":1,"versionName":"1.0.3","createdDate":"30.06.2022 11:30","updatedDate":"30.06.2022 13:00"},
  //   {"RowId":2,"versionName":"1.0.2","createdDate":"29.06.2022 11:30","updatedDate":""},
  //   {"RowId":3,"versionName":"1.0.1","createdDate":"28.06.2022 11:30","updatedDate":"30.06.2022 13:00"}
  // ]
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
      this.getApplicationVersion();
    });
  }
    getApplicationVersion() {
      this.spinner.show();
     this.ApplicationVersionService.getApplicationVersionList(this.ApplicationVersionService.applicationVersionListRequest).then(response => {
       if (response) {
        this.pService.dataSource = response.responseObject;
        this.latestVersionNumber = (response.responseObject)?response.responseObject[0]?.versionNo:'';
        this.paginationSub = this.pService.dealers$.subscribe(result => {
          this.applicationVersionList = this.DataMapper(result);
        });
        this.total$ = this.pService.total$;
        this.spinner.hide();
      }
       else if (response.responseObject && response.responseObject.errorCount > 0) {
           this.spinner.hide();
         }
      this.spinner.hide();
    });
   }
  onAdd() {
    const modalref = this.modalService.open(AddApplicationVersionComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.componentInstance.latestVersionNumber = this.latestVersionNumber;
      modalref.result.then((response) => {
        if (response.success) {
          this.ngOnInit();
        }
   });
  }
  onEdit(id: number) {
    const modalref = this.modalService.open(EditApplicationVersionComponent, { size: 'md', windowClass: 'EditPopup' });
      modalref.componentInstance.applicationVersionId = id;
      modalref.componentInstance.latestVersionNumber = this.latestVersionNumber;
      modalref.result.then((res) => {
        if (res.success) {
          this.ngOnInit();
        }
  });
  }
  VersionNumberChange(){
    this.ApplicationVersionService.applicationVersionListRequest.versionNumber = this.selectedVersionNumber;
   this.getApplicationVersion();
  }
  DataMapper(result:any){

    let supperArray = [];
    if (result && result.length > 0) {
      for (let index = 0; index < result.length; index++) {
        const element = result[index];

        let single = Object();
        single.RowId = this.currentPageNumber(index);
        single.id = element.id;
        single.versionNo = element.versionNo;
        single.updatedDate = element.updatedDate ? new Date(element.updatedDate + 'Z') : null;
        single.createdDate = element.createdDate ? new Date(element.createdDate + 'Z') : null;

        supperArray.push(single);
      }
    }
    return supperArray;
  }
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    } else if (this.pService.page > 1) {
      rtPageNumber =
        Number.parseInt(
          `${this.pService.pageSize * (this.pService.page - 1)}`
        ) +
        (cIndex + 1);
    }

    return rtPageNumber;
  }
  getVersionNumberList(){
    this.ApplicationVersionService.getVersionNumberList().then(response => {
      if (response) {
        this.versionNumberList = this.VersionNumberMapper(response.responseObject);
      }
      else if (response.responseObject && response.responseObject.errorCount > 0) {
          this.spinner.hide();
        }
     this.spinner.hide();
   });
  }
  VersionNumberMapper(result){
    let supperArray = [];
    if (result && result.length > 0) {
      result.forEach(element => {
        let single = Object();
        single.name = element.versionNo;
        single.value = element.versionNo;
        supperArray.push(single);
      });
    }
    return supperArray;
  }
}
